import React from 'react';

//components
import ExperienceAyrFlo from './ExperienceAyrFlo';
import ExperienceMaxTimer from './ExperienceMaxTimer';
import ExperienceDashDraw from './ExperienceDashDraw';
import ExperienceSketchTracer from './ExperienceSketchTracer';
import ExperienceDailynibbler from './ExperienceDailynibbler';
import ExperienceClingOnGrip from './ExperienceClingOnGrip';
import ExperienceSkogen from './ExperienceSkogen';

export default class Experience extends React.Component {

  constructor(props) {
    super(props);
    this.showCarrot=true;
    this.state = {
    };
  }
  componentWillMount(){
    //determine whether to show expandable button in children cards
    if(this.props.showCarrot===false){
      this.showCarrot=false;
    }
  }
  componentDidMount(){
    //determine whether to expand card info
    if(this.props.expanded===true){
      this.expandAllCards();
    }//else keep hidden
  }
  expandAllCards(){
    this.refs.ExperienceAyrFlo.handleExpand();
    this.refs.ExperienceMaxTimer.handleExpand();
    this.refs.ExperienceDashDraw.handleExpand();
    this.refs.ExperienceSketchTracer.handleExpand();
    this.refs.ExperienceDailynibbler.handleExpand();
    this.refs.ExperienceClingOnGrip.handleExpand();
    this.refs.ExperienceSkogen.handleExpand();
  }
  render() {
    return (
      <div className="content-main">
        <ExperienceAyrFlo
          ref='ExperienceAyrFlo'
          showCarrot={this.showCarrot}
        />
        <ExperienceMaxTimer
          ref='ExperienceMaxTimer'
          showCarrot={this.showCarrot}
        />
        <ExperienceDashDraw
          ref='ExperienceDashDraw'
          showCarrot={this.showCarrot}
        />
        <ExperienceSketchTracer
          ref='ExperienceSketchTracer'
          showCarrot={this.showCarrot}
        />
        <ExperienceDailynibbler
          ref='ExperienceDailynibbler'
          showCarrot={this.showCarrot}
        />
        <ExperienceClingOnGrip
          ref='ExperienceClingOnGrip'
          showCarrot={this.showCarrot}
        />
        <ExperienceSkogen
          ref='ExperienceSkogen'
          showCarrot={this.showCarrot}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Experience.js